import { DocumentPage } from '../../context';

export type BasePage = Exclude<DocumentPage, 'success'>;

export const TITLE: Record<BasePage, string> = {
  preContact: 'Sign pre-contract explanation (1/3)',
  creditAgreement: 'Sign credit agreement (2/3)',
  directDebit: 'Sign direct debit agreement (3/3)',
};

export const DESCRIPTION: Record<BasePage, string> = {
  preContact:
    'Here is the pre-contract explanation for your loan. Please review the document carefully and decide whether the terms of the contract have been sufficiently explained to you.',
  creditAgreement:
    'Here is the credit agreement for your loan. Please review the document carefully and decide whether the agreement is suitable for you.',
  directDebit:
    'Here is the direct debit agreement for your loan. Please review the document carefully and decide whether the agreement is suitable for you.',
};
